import React from 'react';
import { useSelector } from 'react-redux';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { SuppressionList } from '@mm/state/model/SuppressionListModel';
import { useSuppressionListsCRUDActions } from '@mm/state/actions/SuppressionListsCRUDActions';
import { ZapierIcon } from '@mm/icons';
import { selectZapierSuppressionList } from '@mm/state/modules/suppressionListsTableState/selectors';
import { Status, Tooltip } from '@mm/components';
import css from './ZapierSuppressionLists.module.css';
import { colors } from '@mm/utils/src/colors';

export const ZapierSuppressionLists = () => {
  const connectedPageId = useSelector(activeFacebookPageIdSelector);
  const { openDeleteConfirmModal } = useModalActions();

  const zapierSuppressions = useSelector(selectZapierSuppressionList);

  const suppressionListsCRUDActions = useSuppressionListsCRUDActions();

  const onDeleteSuppressionList = (suppression: SuppressionList) => {
    const deleteCallback = async () => {
      suppressionListsCRUDActions.deleteList(connectedPageId, suppression);
    };

    openDeleteConfirmModal({
      headerText: `Are you sure you want to delete ${suppression.name}?`,
      deleteCallback,
      newStyle: true,
    });
  };

  return (
    <div className={css.list}>
      {zapierSuppressions.map(item => (
        <div className={css.listItem} key={item.id}>
          <ZapierIcon />

          <span className={css.listTitle}>{item.name}</span>
          {item.suppressionWebhook?.errorInfo ? (
            <div className={css.listError}>
              <Tooltip
                title={
                  typeof item.suppressionWebhook?.errorInfo === 'string'
                    ? item.suppressionWebhook?.errorInfo
                    : `Failed to call the webhook provided. 
                    Please make sure that the URL is correct and the server is reachable.`
                }
              >
                <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
              </Tooltip>
            </div>
          ) : (
            <span className={css.listCount}>{item.profilesCount}</span>
          )}

          <span className={css.listActions}>
            <Status
              status={item.enabled ? 'Active' : 'Disabled'}
              color={!item.enabled ? colors.grayLight : undefined}
            />

            <div className={css.listAction}>
              <div
                className={css.listActionIcon}
                onClick={() => onDeleteSuppressionList(item)}
              >
                <DeleteOutlined />
              </div>
            </div>
          </span>
        </div>
      ))}
    </div>
  );
};
